import script from "./remark-body.vue?vue&type=script&setup=true&lang=ts"
export * from "./remark-body.vue?vue&type=script&setup=true&lang=ts"

import "./remark-body.vue?vue&type=style&index=0&id=dcd3c462&lang=scss"

const __exports__ = script;

export default __exports__